export type CellTone = 'hit' | 'miss' | 'jackpot' | 'neutral';

/**
 * 票的逐位展示态。
 *
 * `matched` 来自后端结算（`bets.milhar_matched`）。
 * **前端不自算输赢** —— player/DESIGN_SYSTEM.md 的技术硬约束。
 * `matched === null` 表示尚未结算，一律中性，绝不猜。
 */
export function ticketCells(
  pick: string,
  matched: number | null,
  isJackpot: boolean,
): CellTone[] {
  const len = pick.length;
  if (matched === null) return Array.from({ length: len }, () => 'neutral');
  if (isJackpot) return Array.from({ length: len }, () => 'jackpot');
  // 后端若因配置漂移下发了比号码还长的 matched，全部高亮，不越界
  const safe = Math.min(Math.max(matched, 0), len);
  return Array.from({ length: len }, (_, i) => (i >= len - safe ? 'hit' : 'miss'));
}
